export enum ApiPaths {
  Token = '/authorize/getAuthorizationToken',
  Logout = '/authorize/logout',
  RefreshToken = '/authorize/refreshToken',
  MediaOutlets = '/requestAccess/getMediaItems',
  Circuits = '/requestAccess/getCircuits',
  Exhibitors = '/requestAccess/getTheatres',
  ForgotPasswordEndpoint = '/authenticate/forgotPassword',
  SavePasswordEndpoint = '/resetPassword/savePassword',
  ValidateToken = '/resetPassword/validateToken',
  UserDetails = '/user/fetch',
  UserDetailsById = '/user/fetchUserById', // GET - pass userId
  EditMyAccount = '/user/updateMyAccount',
  TermsCondition = '/termsAndConditions/fetch',
  RequestAccessTerritory = '/requestAccess/getTerritories',
  RegisterNewUser = '/requestAccess/registerUser',
  ManageTitle = '/titles/getTitles',
  RoleRequestExhibitorProfile = '/requestAccess/fetchRoles',
  AllTheaters = '/manageTheatre/fetchAll',
  TheatersByTerritory = '/manageTheatre/fetchByTerritory',
  RunnerGetAssets = '/runner/fetchRunnerImageURLs',
  RunnerGetImageThumbnail = '/runner/fetchImagePreview',
  RunnerDocumentPreviewUrl = '/runner/getDocumentPreviewUrl',
  RunnerFileUpload = '/runner/upload', // For asset upload
  StripoFileUpload = '/runner/stripoUpload', // For email editor uploads
  AsperaRunnerUpload = '/runner/asperaUpload',
  RunnerUpdateMetadata = '/runner/updateAssetDetailsToRunner', // For updating asset metadata in runner
  AsperaRunnerDownload = '/runner/asperaDownload',
  HttpRunnerDownload = '/runner/httpDownload',
  AssetMappingFetchAssetCategory = '/assetMapping/fetchAssetCategory',
  AssetMappingFetchRunnerMetaData = '/assetMapping/fetchRunnerMetaData',
  CategoryMappingFetchAllAssetCategories = '/categoryMapping/fetchAllAssetCategories',
  CategoryMappingFetchAllRunnerVocab = '/categoryMapping/fetchAllRunnerVocab',
  CategoryMappingFetchRunnerVocab = '/categoryMapping/fetchRunnerVocab', // Returns vocab for a given vocab type
  CategoryMappingFetchAllGAHRunnerMappings = '/categoryMapping/fetchAllGahRunnerMappings',
  CategoryMappingSaveGAHRunnerMapping = '/categoryMapping/saveGahRunnerMapping',
  CategoryMappingDeleteMapping = '/categoryMapping/delete',
  AssetsGetAssets = '/assets/fetchByRelease',
  TitleSearch = '/titles/getTitlesUser',
  EditTitle = '/titles/editTitle',
  FetchTitle = '/titles/getTitle',
  GenreTalentInfo = '/titles/getGenreTalentInfo',
  UpdateDateFormatTerritory = '/manage-homepage/updateDateFormatNreleaseWindow',
  CheckITSupportAccess = '/manage-homepage/itSupportAccess',
  GetFilteredUsersList = '/manageUsers/getUsers', // Use url parameter territoryId and approvalStatusCd
  UserUpdate = '/manageUsers/editUser', // POST request to edit user details
  SearchInternalUser = '/manageUsers/searchIDM',
  AddInternalSonyUser = '/manageUsers/addInternalSonyUser',
  ReviewUserDetails = '/manageUsers/getPendingUsers',
  ReviewUserMediaOutlets = '/manageUsers/getMediaItems',
  LanguageCodes = '/manageUsers/getLanguageCode',
  CircuitList = '/manageUsers/getCircuits',
  TheatreList = '/manageUsers/getTheatres',
  ApproveUser = '/manageUsers/approve',
  RejectUser = '/manageUsers/rejectUser',
  ManageAssets = '/manageAssets/fetch',
  GetDynamicMappings = '/manageAssets/customMetadataValues',
  BulkUpdateAssetStatus = '/manageAssets/bulkUpdateAssetStatus',
  CampaignEmail = '/campaigns/fetch',
  DistributionList = '/distribution-list/fetch',
  DistributionTypeCodes = '/distribution-list/getDistTypeCode',
  CreateDistributionList = '/distribution-list/createDistribution',
  EditDistributionList = '/distribution-list/editDistribution',
  DeleteDistributionList = '/distribution-list/bulkRemove',
  CloneDistributionList = '/distribution-list/cloneDistribution',
  DistributionListById = '/distribution-list/getDistributionList',
  CreateCampaign = '/campaigns/create',
  FetchCampaign = '/campaigns/fetchCampaign',
  UpdateCampaign = '/campaigns/updateCampaign',
  FetchDistributionList = '/distribution-list/fetch',
  FetchDistributionListById = '/distribution-list/fetchDistributionList',
  EditAssets = '/manageAssets/fetchAsset',
  SendCampaign = '/campaigns/sendCampaign',
  ScheduleCampaign = '/campaigns/scheduleCampaign',
  CancelScheduledCampaign = '/campaigns/cancelScheduledCampaign',
  DeletedAssetList = '/manageAssets/fetchDeletedAssets',
  SaveUserDistributionList = '/distribution-list/saveUserDistList',
  SubscribedDistributionList = '/distribution-list/fetchSubscribedList',
  UpdateThumbnail = '/runner/updateThumbnail',
  fetchUserSubscription = '/user/fetchUserSubscription',
  saveUserDistList = '/distribution-list/saveUserDistList',
  GetUserGroupTerritory = '/manageUsers/getUserTerritory',
  fetchRunnerFolderIds = '/manage-homepage/fetchRunnerInfo',
  updateRunnerFolderIds = '/manage-homepage/updateFolderIds',
  UpdateUserAssignTerritory = '/manageUsers/updateUserAssignedTerritory',
  ContactUsSubjectList = '/contact-us/fetchSubjectList',
  SaveContactUsDetails = '/contact-us/saveContactUsDetails',
  fetchContactUsDetails = '/manage-homepage/fetchContactDirectoryData',
  // Assets
  AssetsLocalTitleNames = '/assets/localTitleNames',
  AssetsExistingMedia = '/assets/existingCampaignMedia',
  AssetsSearchExistingAssets = '/assets/searchExistingAssets',
  AssetsFetchByRelease = '/assets/fetchByRelease',
  FetchRunnerInfo = '/manage-homepage/fetchRunnerInfo',
  UpdateRunnerInfo = '/manage-homepage/updateRunnerInfo',
  saveHomePageHeaderMediaAssets = '/manage-homepage/saveHomePageHeaderMediaAssets',
  removeHomePageHeaderMediaAssets = '/manage-homepage/removeHomePageMediaAssets',
  fetchHomePageHeaderMediaAssets = '/manage-homepage/fetchHomePageHeaderMediaAssets',
  fetchContactDirectoryData = '/manage-homepage/fetchContactDirectoryData',
  updateExistingAssetDisplayOrder = '/assets/updateExistingAssetDisplayOrder',
  fetchRolePrivileges = 'homePage/fetchUserTerritoryPrivileges',
  GetRestrcitedAssets = '/runnerAssetDownloadRequest/getRestrictedAssets',
  updateAssetReqStatus = '/runnerAssetDownloadRequest/updateAssetReqStatus',
  RunnerAssetDownloadRequest = '/runnerAssetDownloadRequest/saveDownloadAccessRequest',
  FetchHomePageData = 'homePage/fetchHomePageReleaseInfo',
  FetchHomePageHeaderMediaData = 'homePage/fetchHomePageInfoForHeaderMedia',
  fetchTranslations = '/manage-homepage/fetchTranslations',
  updateTranslations = '/manage-homepage/updateTranslationValue',
  AssetsFetchByRunnerReleaseId = '/assets/fetchByRunnerAssetRelease',
  fetchGAHActiveTerritories = '/manageAssets/fetchGAHActiveTerritories',
  //Digital Cart
  AddtoDigitalCart = '/digital-cart/add',
  RemoveFromDigitalCart = '/digital-cart/remove',
  GetCartAssetsInfo = 'digital-cart/fetch',
  UpdateUserPreferences = '/user/updatePreferences',
  fetchUserMenuMap = '/homePage/fetchUserMenus',
  fetchSharePermissions = '/digital-cart/sharePermissions',
  BulkRemoveAssets = '/digital-cart/bulkRemove',
  EmailBulkAssets = '/digital-cart/emailAssets',
  UploadUserGuide = '/userguide/uploadUserGuide', //Upload User guide
  RemoveUserGuide = '/userguide/removeUserGuide', //Remove User guide
  FetchUserGuide = '/userguide/fetchUserGuide', //Fetch User guide
  GetUserGuideFile = '/userguide/getUserGuideFile', //Get user guide file
  FetchEmailNotifications = '/manage-homepage/fetchNotificationEmails',
  UpdateEmailNotifications = '/manage-homepage/updateEmailNotifications',
  FetchUpdatedUserPreferences = '/homePage/fetchUserPreferences',
  EmailHeaderUpload = '/manage-homepage/emailHeaderUpload',
  EmailHeaderFetch = '/manage-homepage/fetchEmailHeader',
  GetTranslationFile = '/homePage/fetchTranslationFile',
  GlobalSearch = '/global-search/search', //Global Search
  RemoveEmailHeader = '/manage-homepage/removeEmailHeader',
  FetchFooterLinks = '/homePage/fetchFooterLinks',
  FetchOrderInPOSAndTheatreData = '/orderin-theatre-and-pos/fetchData',
  SaveOrderInPOSAndTheatreData = '/orderin-theatre-and-pos/saveOrderEmail',
  fetchTermsOfUse = '/termsAndConditions/fetchTermsOfUse',
  FetchTimeZone = '/user/fetchTimeZone',
  RunnerAssetUploadStatus = '/runner/checkAssetUploadStatus', // For asset upload status
  ManageAssetFilterStorage = '/manageAssets/manageAssetsFilterStore', //GAHR-489 Manage Asset Filter Store
  FetchManageAssetFilters = '/manageAssets/fetchAssetsFilterStore', //GAHR-489 Fetch Manage Asset Filter Store
  FetchAssetThumbnailUrl = '/assets/fetchTumbnailUrl',
  HomeHeaderMediaUpload = '/runner/homeHeaderMediaUpload',
  DeleteCampaigns = '/campaigns/deleteCampaigns',
  GenerateAssetURL = '/manageassetlink/generateTokenForAssetURL',
  // IT services
  LoadAssetsToOpenSearch = '/manageAssets/loadOpenSearchAssets',
  LoadTitlesToOpenSearch = '/titles/loadOpenSearchTitles',
  AssetDownload = '/manageassetlink/downloadAsset', //GAHR-737
  FetchAssetDimensions = '/runner/fetchAssetDimensions', //GAHR-737
  DownloadAssetAsPerProxy = '/runner/downloadAssetAsPerProxy', //GAHR-737
  FetchAssetDimensionsAssetView = '/manageassetlink/fetchAssetDimensionsAssetView', //GAHR-682
  DownloadAssetAsPerProxyAssetView = '/manageassetlink/downloadAssetAsPerProxyAssetView', //GAHR-682
  FetchImagePreviewAssetView = '/manageassetlink/fetchImagePreviewAssetView', //GAHR682
  FetchActiveTerritories = '/user/fetchUserGroupTerritories', //GAHR760,1061,1287
  FetchAssetSharePermissions = '/manageassetlink/getAssetSharePermissions',
  // Social Media Links
  FetchSocialMediaLinks = '/social-media/fetchSocialMedia',
  ValidateExclusiveLink = '/manageassetlink/validateExclusiveLink', //GAHR756
  ValidateLinkRecipient = '/manageassetlink/validateLinkRecipient', //GAHR756
  FetchAssetViewDetails = '/manageassetlink/validateAndFetchAssetInformation',
  SharedAssetBulkDownload = '/manageassetlink/sharedAssetBulkDownload', //GAHR774
  GAHAccountRoles = '/manageUsers/getUserAccountRoles', //GAHR578
  FetchTitlesForRecentPublished = '/homePage/fetchTitlesForRecentPublished',
  EditTitleThumbnailUrl = '/titles/editTitleThumbnailUrl',
  SeeAllAssets = '/assets/seeAllAssets',
  EditTitleMetadataVisibility = '/titles/editTitleMetadataVisibility',
  getTerritoryReleaseWindow = '/manage-homepage/fetchReleaseWindow',
  DeleteAssets = '/manageAssets/deleteAssetFromRunner', //GAHR1285
  UpdatePendingUserInfo = '/manageUsers/updatePendingUserInformation', //GAHR1313
  FetchRequestRolecode = '/user/fetchRequestRoleForSwitchTerr', //GAHR1313
  
  FetchAutoPublishConfiguration = '/runner/fetchAutoPublishConfig', //GAHR-1162
  FetchAdminRoles = '/manageUsers/getAdminRoles', //GAHR1313
  AddUserAssignTerritory = '/manageUsers/addUserAssignedTerritory', //GAHR1350
  ReplaceAssets = "/manageAssets/replaceAssetFromRunner",//Gahr-1325
}
